import React, { Component } from "react";
// import MyNav from "./nav";
// import Home from "./home";
import InfoBox from "./infobox";
import "bootstrap/dist/css/bootstrap.min.css";
import CompanyTable from "./companyTable";
import firebase from "firebase";
import "firebase/database";
import "firebase/auth";
import Company from "./company";
import AutoDetect from "./auto-detect";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Form, Dropdown } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead"; // ES2015
import "react-bootstrap-typeahead/css/Typeahead.css";
// import { getAuth, linkWithCredential, onAuthStateChanged } from "firebase/auth";
// import Contribute from "./contribute";
import { Button } from "@material-ui/core";
import Trends from "./trends";
import { getLogoURL } from "../App";
import { GoogleLogin } from "react-google-login";
import "../css/routers.css";
import PageNotFound from "./pageNotFound";
//463964052420-nl5o34qlunn6abg90dp9e8jnqpsge8qm.apps.googleusercontent.com
class Routers extends Component {
  constructor() {
    super();

    this.state = {
      urlsReceived: false,
      companies: {},
      writeBtnMsg: "Hello",
    };

    const config = {
      apiKey: "AIzaSyB9ipmmvaR9piY16zHNYK3oxQw2zaZ6cgI",
      authDomain: "status-fyi.firebaseapp.com",
      databaseURL: "https://status-fyi-default-rtdb.firebaseio.com",
      projectId: "status-fyi",
      storageBucket: "status-fyi.appspot.com",
      messagingSenderId: "585425640574",
      appId: "1:585425640574:web:6c1a38ae0bb3ceee9d4c2f",
    };

    if (!firebase.apps.length) {
      this.app = firebase.initializeApp(config);
    } else {
      this.app = firebase.app(); // if already initialized, use that one
    }

    // Get a reference to the database service
    this.database = this.app.database();

    this.writeTestDB = this.writeTestDB.bind(this);
  }

  async writeTestDB() {
    const user = firebase.auth().currentUser;
    if (user) {
      // User is signed in.
      console.log(user);
      firebase
        .auth()
        .signOut()
        .then(() => {
          // Sign-out successful.
          console.log("signedout");
        })
        .catch((error) => {
          // An error happened.
          console.log("signout error");
        });
    } else {
      // No user is signed in.
      //   firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
      //     document.getElementById("message").innerHTML = error.message;
      //   });

      const provider = new firebase.auth.GoogleAuthProvider();
      console.log("provider", provider);
      await firebase
        .auth()
        .signInWithPopup(provider)
        .then((user) => {
          console.log(user);
        })
        .catch(console.log);
    }

    // Add a new document in collection "cities"
    let companyName = "Google";
    let numInterviews = 5;
    // let recStatus = "Offering 2nd round interviews";
    let recStatus = "Giving out offers";
    // let recStatus = "Accepting applications";
    // const firestore = firebase.firestore();

    // console.log(firestore.doc(this.database, "companies", companyName));
    console.log("hello");
    firebase
      .firestore()
      .collection("companies")
      .doc(companyName)
      .set({
        name: companyName,
        interviews: numInterviews,
        recruitingStatus: recStatus,
        numApplied: 0,
        numFirst: 0,
        numSecond: 0,
        numThird: 0,
        numFourth: 0,
        numOffered: 0,
        numRejected: 0,
        // dates: firebase.firestore().collection(this.database, companyName+"Dates"),
      })
      .then(function () {
        // ...
        // note: you can get the new document ID by using doc.id
        // this.setState({ writeBtnMsg: "Goodbye" }, () => {
        // firebase
        //   .auth()
        //   .signOut()
        //   .then(() => {
        //     // Sign-out successful.
        //     console.log("signedout");
        //   })
        //   .catch((error) => {
        //     // An error happened.
        //     console.log("signout error");
        //   });
        // });
      })

      .catch(function (error) {
        console.log(error);
      });
  }

  debug() {
    console.log(this.state.urlsReceived);
    return true;
  }

  async componentDidMount() {
    // this.writeTestDB();
    // const companyNames = [];
  }

  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/">
              <div
                className="extraBg"
                style={{
                  backgroundColor: "#cf4c2b",
                  // background: "rgb(2,0,36)",
                  // background:
                  //   "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(41,196,176,1) 39%, rgba(0,212,255,1) 99%)",
                  paddingBottom: "75px",
                  marginBottom: "-105px",
                }}
              ></div>
              <InfoBox />
              <div className="container" style={{ alignItems: "center" }}>
                {/* <Button onClick={this.writeTestDB.bind(this)}>
                  {this.state.writeBtnMsg}
                </Button>

                <Trends /> */}

                <div
                  className="fixed-table-container"
                  style={{ paddingBottom: "0px" }}
                >
                  <CompanyTable
                    companies={this.state.companies}
                    className="hs"
                  />
                </div>
              </div>
            </Route>
            <Route path="/company/:id/:category" component={Company} />
            {/* <Route
              path="/auto-detect/:companyName/:jobTitle"
              component={AutoDetect}
            /> */}
            <Route path="**" component={PageNotFound} />
            {/* <Route path={"/contribute"} key={"contribute"}> */}
            {/* <Contribute
                companies={this.state.companies}
                companyNames={this.state.companyNames}
              /> */}
            {/* </Route> */}
          </Switch>
        </Router>
      </div>
    );
  }
}

export default Routers;
